/* istanbul ignore next */
export const staticSuffix = 'post-purchase'; // eslint-disable-line
export const micrositeName = 'yoda-microsite-post-purchase'; // eslint-disable-line
export const isContextHeadersRequired = true;
export const configServerSettingsFlag = true;
export const esiHeaderRequiredRoutes = null;
export const shallowFirstServerRendering = false;

export const app = {
    logTag: 'MICROSITE:POST-PURCHASE',
};

export const cachePolicy = {
    version: 1,
    enabled: false,
    minCache: 86400, // Default 30 mins
    routeCache: {
        // Not supported yet
        match: '/orders',
        minCache: 0,
        enabled: false,
    },
};
